module.exports = __webpack_public_path__ + "media/customizations/bryson/logo-cf84d961234bbe94a75628aa7d44be00.png";